import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

function ResultPanel({ title = 'Result', items }) {
  if (!items?.length) return null;

  return (
    <Box
      sx={{
        mt: 1,
        p: 2,
        bgcolor: 'grey.50',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography variant="subtitle1" gutterBottom>
        {title}
      </Typography>
      <Grid container spacing={2}>
        {items.map((item) => (
          <Grid item xs={12} sm={item.fullWidth ? 12 : 6} key={item.label}>
            <Typography variant="body2" color="text.secondary">
              {item.label}
            </Typography>
            <Typography
              variant="h5"
              color="primary"
              sx={{ fontSize: { xs: '1.35rem', sm: '1.5rem' }, wordBreak: 'break-word' }}
            >
              {item.value}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default ResultPanel;
